export default "__VITE_ASSET__a8db2305__"